import { usePatternFormat } from 'react-number-format'

import { MaskedText } from '../baseInputs'

type Props = {
  helper?: string
}

const DateOfBirthMask = ({ helper, ...rest }: Props) => {
  const name = 'dob'
  const label = 'Date of Birth'

  const { format } = usePatternFormat({
    format: '##/##/####',
    mask: ['_'],
  })

  return (
    <MaskedText
      format={format}
      name={name}
      label={label}
      helper={helper}
      {...rest}
    />
  )
}

export default DateOfBirthMask
